<template>
    <div
        :class="
            compact ? 'm-4 text-center' : 'm-10 sm:mx-auto sm:w-4/5 text-center'
        "
    >
        <div class="mb-3 flex justify-center">
            <div
                :class="[
                    'flex items-center justify-center rounded-full bg-taupe-100 text-taupe-400',
                    compact ? 'h-8 w-8' : 'h-12 w-12',
                ]"
            >
                <component
                    :is="icon"
                    :css-classes="compact ? 'h-4 w-4' : 'h-6 w-6'"
                />
            </div>
        </div>
        <h3
            v-if="title"
            :class="[
                'font-medium text-taupe-700',
                compact ? 'text-sm' : 'text-lg',
            ]"
        >
            {{ title }}
        </h3>
        <div
            :class="['text-taupe-500 italic', compact ? 'text-sm' : 'text-lg']"
        >
            <slot />
        </div>
    </div>
</template>

<script setup>
import ZenIconBoxEmpty from './Icons/IconBoxEmpty.vue'

defineProps({
    title: {
        type: String,
        default: null,
    },
    compact: {
        type: Boolean,
        default: false,
    },
    icon: {
        type: [Object, Function, String],
        default: () => ZenIconBoxEmpty,
    },
})
</script>
